var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentSite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-content-site") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-content-site",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0,
    stroke: "#FFFFFF",
    x: 3,
    y: 3,
    width: 24,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#53575C",
    transform: "translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) ",
    x: 5.5,
    y: 5.5,
    width: 19,
    height: 19,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#53575C",
    transform: "translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) ",
    x: 11,
    y: 11,
    width: 8,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8.5 L12.0356445,12.0356445 M18.0406494,18.0406494 L21.5,21.5",
    id: "Shape",
    stroke: "#53575C",
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentSite);
export default __webpack_public_path__ + "static/media/ic-content-site.b624eb9241f9e49c9fdd2242712d487d.svg";
export { ForwardRef as ReactComponent };